import { render, staticRenderFns } from "./icon-task-folder.vue?vue&type=template&id=7657c308&"
import script from "./icon-task-folder.vue?vue&type=script&lang=ts&"
export * from "./icon-task-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports